"use strict";

const images = document.querySelectorAll(".gallery-preview");
images.forEach(img => img.classList.add("transition"));
const backgroundSequence = () => {
  window.clearTimeout();
  let k = 0;
  for (let i = 0; i < images.length; i++) {
    setTimeout(function () {
      document.querySelectorAll(".gallery-preview").forEach(preview => {
        preview.classList.add("opacity-0");
      });
      if (images[k]) {
        images[k].classList.remove("opacity-0");
      }
      if (k + 1 === images.length) {
        setTimeout(backgroundSequence, 2000);
      } else {
        k++;
      }
    }, 3000 * i);
  }
};
if (images.length > 1) {
  backgroundSequence();
}
//# sourceMappingURL=galleryPreview.js.map